import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import {
  WarrantLegalRepresentativeCreationPayload,
  WarrantLegalRepresentativeCreationResponseData,
} from './warrants-legal-representative.types';

// createSilobagService
export async function warrantLegalRepresentativeCreationService({
  body,
}: WarrantLegalRepresentativeCreationPayload) {
  const { response, data } = await BACKEND.post<WarrantLegalRepresentativeCreationResponseData>(
    ENDPOINT.WARRANT_LEGAL_REPRESENTATIVE,
    { body }
  );

  return {
    response,
    summary: data,
  };
}
